// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2fNG6","notes":"Notes_notes__eQ1Mq"};